import React, { Component, PropTypes } from 'react';
import '../styles/browserNotSupported.scss';
import Persistence from '../Persistence/Persistence'

class BrowserNotSupportedComponent extends Component {
  constructor() {
    super();
  }

  onDeclineClick(event) {

  }

  onAcceptClick(event) {
    Persistence.setHasAcceptedEULA(true);
    this.props.delegate.onEULAAccepted();
  }

  render() {
    return (
      <div className={"notSupportedRoot"}>
        <div className={"notSupportedText"}>
          Aspirin Guide is not optimized for this browser. Please use either Chrome, Firefox, Safari, or Microsoft Edge instead.
          </div>
  </div>

    );
  }

}

export default BrowserNotSupportedComponent;



/** WEBPACK FOOTER **
 ** ./src/components/BrowserNotSupportedComponent.js
 **/